import * as type from '../../../actions/index.types'

const initialState = {
    // GET /api/shifts/enums — break types and the labelled weekday list.
    shiftEnums: null,

    // Shift definitions
    shifts: [],
    shiftsPagination: null,
    shiftsLoading: false,
    shiftDetails: null,
    shiftDetailsLoading: false,
    // create / update / delete share one flag — the form and the delete dialog
    // are never open at the same time.
    shiftMutationLoading: false,

    // Assignments
    assignments: [],
    assignmentsPagination: null,
    assignmentsLoading: false,
    assignmentDetails: null,
    assignmentDetailsLoading: false,
    // create / update / end / delete
    assignmentMutationLoading: false,
}

export function ShiftReducer(state = initialState, action) {
    switch (action.type) {
        // ---- Enums --------------------------------------------------------
        case type.SOCIETY_GET_SHIFT_ENUMS_SUCCESS:
            return { ...state, shiftEnums: action.payload || null }
        case type.SOCIETY_GET_SHIFT_ENUMS_FAILURE:
            return state

        // ---- Shift definitions --------------------------------------------
        case type.SOCIETY_GET_SHIFTS:
            return { ...state, shiftsLoading: true }
        case type.SOCIETY_GET_SHIFTS_SUCCESS:
            return {
                ...state,
                shiftsLoading: false,
                shifts: action.payload?.rows || [],
                shiftsPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_SHIFTS_FAILURE:
            return { ...state, shiftsLoading: false }

        case type.SOCIETY_GET_SHIFT_DETAILS:
            return { ...state, shiftDetailsLoading: true }
        case type.SOCIETY_GET_SHIFT_DETAILS_SUCCESS:
            return { ...state, shiftDetailsLoading: false, shiftDetails: action.payload || null }
        case type.SOCIETY_GET_SHIFT_DETAILS_FAILURE:
            return { ...state, shiftDetailsLoading: false }

        case type.SOCIETY_CREATE_SHIFT:
        case type.SOCIETY_UPDATE_SHIFT:
        case type.SOCIETY_DELETE_SHIFT:
            return { ...state, shiftMutationLoading: true }
        case type.SOCIETY_CREATE_SHIFT_SUCCESS:
        case type.SOCIETY_CREATE_SHIFT_FAILURE:
        case type.SOCIETY_UPDATE_SHIFT_SUCCESS:
        case type.SOCIETY_UPDATE_SHIFT_FAILURE:
        case type.SOCIETY_DELETE_SHIFT_SUCCESS:
        case type.SOCIETY_DELETE_SHIFT_FAILURE:
            return { ...state, shiftMutationLoading: false }

        // ---- Assignments ---------------------------------------------------
        case type.SOCIETY_GET_SHIFT_ASSIGNMENTS:
            return { ...state, assignmentsLoading: true }
        case type.SOCIETY_GET_SHIFT_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                assignmentsLoading: false,
                assignments: action.payload?.rows || [],
                assignmentsPagination: action.payload?.pagination || null,
            }
        case type.SOCIETY_GET_SHIFT_ASSIGNMENTS_FAILURE:
            return { ...state, assignmentsLoading: false }

        case type.SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS:
            return { ...state, assignmentDetailsLoading: true }
        case type.SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_SUCCESS:
            return { ...state, assignmentDetailsLoading: false, assignmentDetails: action.payload || null }
        case type.SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_FAILURE:
            return { ...state, assignmentDetailsLoading: false }

        case type.SOCIETY_CREATE_SHIFT_ASSIGNMENT:
        case type.SOCIETY_UPDATE_SHIFT_ASSIGNMENT:
        case type.SOCIETY_END_SHIFT_ASSIGNMENT:
        case type.SOCIETY_DELETE_SHIFT_ASSIGNMENT:
            return { ...state, assignmentMutationLoading: true }
        case type.SOCIETY_CREATE_SHIFT_ASSIGNMENT_SUCCESS:
        case type.SOCIETY_CREATE_SHIFT_ASSIGNMENT_FAILURE:
        case type.SOCIETY_UPDATE_SHIFT_ASSIGNMENT_SUCCESS:
        case type.SOCIETY_UPDATE_SHIFT_ASSIGNMENT_FAILURE:
        case type.SOCIETY_END_SHIFT_ASSIGNMENT_SUCCESS:
        case type.SOCIETY_END_SHIFT_ASSIGNMENT_FAILURE:
        case type.SOCIETY_DELETE_SHIFT_ASSIGNMENT_SUCCESS:
        case type.SOCIETY_DELETE_SHIFT_ASSIGNMENT_FAILURE:
            return { ...state, assignmentMutationLoading: false }

        default:
            return state
    }
}
